// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2pSyw","calendarButtons":"ClockData_calendarButtons__13yBB"};